const roundMinPriceToPreviousIncrement = (appliedRange, range, increment) => {
  const min = Number.isFinite(+appliedRange?.min)
      ? appliedRange.min
      : (range && range.min);
  const minValue = min - (min % increment);

  return minValue;
};

export default roundMinPriceToPreviousIncrement;